module.exports = __webpack_public_path__ + "static/media/CELO.11172661.svg";